export type { ManualGhostTextProps, ManualGhostTextRef } from './ManualGhostText';
export { ManualGhostTextPlugin } from './ManualGhostText';
